import {
  AttributeDefinition,
  AttributeName,
  AttributeType,
} from "@keita/lanepatrol-sdk";
import { t } from "i18next";
import { attributeImageMap } from "./attribute-images";

export namespace AttributeUtils {
  export const getOptionLabel = (value: string) =>
    t(`sdk:attribute.option.${value}`);

  export const getLabel = (attributeName: AttributeName) =>
    t(`sdk:attribute.label.${attributeName}`);

  export const getPlaceholder = (attributeName: AttributeName) =>
    t(`sdk:attribute.placeholder.${attributeName}`);

  export const getValueLabel = (
    attribute: AttributeDefinition,
    value: null | string | number,
  ): string => {
    if (value === null) return "-";
    if (value && attribute.type === AttributeType.Select) {
      return t(`sdk:attribute.option.${value}`);
    }
    return `${value}`;
  };

  export const getImage = (
    definition: AttributeDefinition,
    value: string | number | null,
  ): string | undefined => {
    const maybeImage = attributeImageMap[definition.name];

    // attribute has no image
    if (!maybeImage) return maybeImage;

    // attribute has image
    if (typeof maybeImage === "string") return maybeImage;

    // attribute has value dependent image, but the value is null
    if (!value) return undefined;

    // attribute has value dependent image and value is not null
    return maybeImage[value as string];
  };
}
